import { env } from '@/env';

/**
 * Build a URL for any CDN-hosted resource.
 * @param {string} path - Path relative to CDN root (e.g., 'datasets/cities.json')
 */
export function getCdnUrl(path) {
  return `${env.cdnOrigin}/${path}`;
}
